<template>
    <v-row>
        <v-col cols="12">
            <v-card class="card--flex-toolbar">
                <v-toolbar
                    flat
                >
                    <v-toolbar-title class="grey--text">Reporte de Referidos</v-toolbar-title>
                </v-toolbar>
                <v-container grid-list-md style="max-width: initial; padding: 20px;">
                    <v-form>
                        <v-row>
                            <v-col xs="12" md="6">
                                <v-dialog
                                    ref="dialog"
                                    v-model="modal_desde"
                                    :return-value.sync="filter.desde"
                                    persistent
                                    width="290px"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            v-model="filter.desde"
                                            label="Desde:"
                                            prepend-icon="event"
                                            readonly
                                            clearable
                                            @click:clear="filter.hasta = null"
                                            v-on="on"
                                        />
                                    </template>
                                    <v-date-picker
                                        v-model="filter.desde"
                                        locale="es-MX"
                                        scrollable
                                    >
                                        <v-spacer/>
                                        <v-btn color="gray" @click="modal_desde = false">
                                            Cancelar
                                        </v-btn>
                                        <v-btn color="primary" @click="$refs.dialog.save(filter.desde)">
                                            Aceptar
                                        </v-btn>
                                    </v-date-picker>
                                </v-dialog>
                            </v-col>
                            <v-col xs="12" md="6">
                                <v-dialog
                                    ref="dialog2"
                                    v-model="modal_hasta"
                                    :return-value.sync="filter.hasta"
                                    persistent
                                    width="290px"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            v-model="filter.hasta"
                                            label="Hasta:"
                                            prepend-icon="event"
                                            :disabled="filter.desde === null"
                                            readonly
                                            clearable
                                            v-on="on"
                                        />
                                    </template>
                                    <v-date-picker
                                        v-model="filter.hasta"
                                        :min="filter.desde"
                                        locale="es-MX"
                                        scrollable
                                    >
                                        <v-spacer/>
                                        <v-btn color="gray" @click="modal_hasta = false">
                                            Cancelar
                                        </v-btn>
                                        <v-btn color="primary" @click="$refs.dialog2.save(filter.hasta)">
                                            Aceptar
                                        </v-btn>
                                    </v-date-picker>
                                </v-dialog>
                            </v-col>
                            <v-col xs="12" md="6">
                                <SearchClientesInput
                                    @selected="filter.referido_id = $event"
                                ></SearchClientesInput>
                            </v-col>
                            <v-col xs="12" md="6">

                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>

                <v-card-actions>
                    <p class="font-weight-regular grey--text text--darken-2" v-if="false">
                        * De forma predeterminada se muestran los últimos 30 días si no aplicas los filtros de fecha
                    </p>
                    <v-spacer/>
                    <v-btn
                        color="blue darken-1"
                        class="white--text"
                        :loading="loading"
                        @click="listar()"
                    >
                        Buscar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-col>
        <v-col cols="12">
            <v-data-table
                :headers="headers"
                :items="pedidos"
                :options.sync="options"
                class="elevation-1"
                :sort-by="'users.id'"
                :sort-desc="false"
                :loading="loading"
                :server-items-length="pedidosTotal"
                :footer-props="{itemsPerPageOptions : $root.OPTIONS_PER_PAGE_DATATABLE}"
                @update:options="listar"
            >
                <template v-slot:item.referidor="{item}">
                    {{item.referidor.nombre_completo}}
                </template>
                <template v-slot:item.referido="{item}">
                    {{item.referido.nombre_completo}}
                </template>
                <template v-slot:item.aplicada="{item}">
                    <v-chip v-if="item.cancelado"
                            dark
                            class="red"
                    >
                        Cancelado
                    </v-chip>
                    <v-chip
                            v-else
                            dark
                            :class="{'teal' : item.aplicada, 'gray' : !item.aplicada}"
                    >
                        {{ item.aplicada ? 'Aplicada' : 'No Aplicada' }}
                    </v-chip>
                </template>
                <template v-slot:item.importe_referidor="{item}">
                    {{$_currency(item.importe_referidor, true)}}
                </template>
                <template v-slot:item.importe_referido="{item}">
                    {{$_currency(item.importe_referido, true)}}
                </template>
                <template v-slot:item.actions="{item}">
                    <template v-if="!item.aplicada && !item.cancelado">
                        <v-tooltip left>
                            <template v-slot:activator="{ on }">
                                <v-icon
                                        small
                                        class="mr-2"
                                        v-on="on"
                                        v-text="'mdi-cash'"
                                        color="green"
                                        @click="editarImportes(item)"
                                >
                                </v-icon>
                            </template>
                            <span>Modificar Recompensas</span>
                        </v-tooltip>
                        <v-tooltip left>
                            <template v-slot:activator="{ on }">
                                <v-icon
                                        small
                                        class="mr-2"
                                        v-on="on"
                                        v-text="'mdi-cancel'"
                                        color="red"
                                        @click="cancelarRecompensa(item)"
                                >
                                </v-icon>
                            </template>
                            <span>Cancelar Recompensa</span>
                        </v-tooltip>
                    </template>

                </template>
            </v-data-table>
            <v-dialog
                    v-model="dialog_importes"
                    max-width="80%"
                    persistent
                    scrollable
            >
                <v-card>
                    <form-importes-referenciados
                            v-if="dialog_importes"
                            :id-item="itemSelectId"
                            @close="dialog_importes = false"
                            @save="saveItem"
                    />
                </v-card>
            </v-dialog>
            <v-dialog
                    v-model="dialog_cancelar"
                    max-width="600px"
                    persistent
            >
                <v-card>
                    <v-card-title>
                        <span class="headline">Cancelar Recompensa</span>
                    </v-card-title>
                    <v-card-text>
                        ¿Esta seguro que quiere cancelar la recompensa?
                        <v-flex xs12 sm6>
                            <v-text-field
                                    :value="observacion_cancelacion"
                                    :error-messages="error_input.observacion_cancelacion"
                                    label="Motivo Cancelacion"
                                    @input="(payload) => observacion_cancelacion = payload"
                            />
                        </v-flex>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer/>
                        <v-btn
                                color="gray darken-1"
                                @click="dialog_cancelar = false"
                        >
                            No
                        </v-btn>
                        <v-btn
                                color="red darken-1"
                                class="white--text"
                                :loading="loading_cancelar"
                                :disabled="loading_cancelar"
                                @click="cancelItem"
                        >
                            Si
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-col>
    </v-row>
</template>

<script>
    import axios from 'axios';
    import SearchClientesInput from "@components/SearchClientesInput";
    import FormImportesReferenciados from "@components/FormImportesReferenciados";
    import EventBus from '../../EventBus'

    export default {
        name: "ProductosPorCliente",
        components : {
            SearchClientesInput,
            FormImportesReferenciados
        },
        data(){
            return {
                observacion_cancelacion:"",
                dialog_cancelar:false,
                dialog_importes:false,
                loading_cancelar:false,
                itemSelectId:null,
                filter : {
                    desde : null,
                    hasta : null,
                    referido_id : []
                },
                headers: [
                    {
                        text: 'Referidor',
                        align: 'left',
                        sortable: true,
                        value: 'referidor',
                        width: '150px'
                    },
                    {
                        text: 'Importe Referidor',
                        align: 'center',
                        sortable: true,
                        value: 'importe_referidor',
                        width: '150px'
                    },
                    {
                        text: 'Referido',
                        align: 'left',
                        sortable: true,
                        value: 'referido',
                        width: '150px'
                    },
                    {
                        text: 'Importe Referido',
                        align: 'center',
                        sortable: true,
                        value: 'importe_referido',
                        width: '150px'
                    },
                    {
                        text: 'Estatus Recompensa',
                        align: 'left',
                        sortable: true,
                        value: 'aplicada',
                        width: '170px'
                    },
                    {
                        text: 'Fecha Creacion',
                        align: 'left',
                        sortable: true,
                        value: 'created_at',
                        width: '150px'
                    },
                    {
                        text: 'Fecha Aplicacion',
                        align: 'left',
                        sortable: true,
                        value: 'fecha_aplicacion',
                        width: '150px'
                    },
                    {
                        text: 'Opciones',
                        align: 'left',
                        sortable: true,
                        value: 'actions',
                        width: '150px'
                    }
                ],
                loading: false,
                modal_desde: false,
                modal_hasta: false,
                pedidos: [],
                pedidosTotal: 0,
                options: {
                    descending: true,
                    page: 1,
                    itemsPerPage: this.$root.OPTIONS_PER_PAGE_DATATABLE[0],
                    totalItems: 0
                },
                error_input:[],
            }
        },
        computed : {
            totalPedidosCountPorPagina(){
                return this.pedidos.reduce((total,item) => total + parseInt(item.pedidos_count),0);
            },
            totalPedidosMontoPorPagina(){
                return this.pedidos.reduce((total,item) => total + parseFloat(item.pedidos_monto),0);
            }
        },
        methods : {
            cancelItem(){
                if(!this.observacion_cancelacion){
                    EventBus.$emit('tugarrafon:show-snackbar', {
                        color: 'error',
                        text_content: "Debe de especificar un motivo de cancelacion"
                    });
                    return;
                }
                this.loading_cancelar = true;
                axios.post(`/api/codigo_referencia_historial/cancelar/${this.itemSelectId}`, {
                    observacion_cancelacion: this.observacion_cancelacion
                })
                    .then(()=>{

                    })
                    .finally(()=>{
                    this.loading_cancelar = false;
                })
            },
            saveItem(){
                this.dialog_importes = false;
                this.listar();
            },
            cancelarRecompensa({id}){
                this.observacion_cancelacion = "";
                this.itemSelectId = id;
                this.dialog_cancelar = true;
            },
            editarImportes({id}){
                this.itemSelectId = id;
                this.dialog_importes = true;
            },
            listar(){
                if(this.loading === false){

                    this.loading = true;
                    const {sortBy, sortDesc, page, itemsPerPage} = this.options;
                    axios.get('/api/reportes/clientes/referidos', {
                        params: {
                            sortBy: sortBy, sortDesc: sortDesc, page: page, rowsPerPage: itemsPerPage,
                            search: this.search,
                            ...this.filter
                        }
                    })
                        .then(({data}) => {
                            this.loading = false;
                            this.pedidos = data.data;
                            this.pedidosTotal = data.total;
                            this.options.page = data.current_page;
                        }).catch(() => {
                            this.loading = false;
                    })
                }
            }
        }
    }
</script>

<style scoped>

</style>
